import { useEffect, useState, useContext } from "react";

import CardProductsV2 from "../cardsProductsV2/cardProductsV2";
import api from "../../api/api";
import MyContext from "../../globalState/globalState";

//importação das imagens
import comprar1 from "../../Assets/images/ico_escolha1.png";
import comprar2 from "../../Assets/images/ico_escolha2.png";
import comprar3 from "../../Assets/images/ico_escolha3.png";
import comprar4 from "../../Assets/images/ico_escolha4.png";
import comprar5 from "../../Assets/images/ico_escolha4.png";

function SectionProducts({ item, tituloImg, img, texto, log, moduleID }) {
  const [produtosARQ, setProdutosARQ] = useState([]);
  const [produtosCRT, setProdutosCRT] = useState([]);
  const [produtosCRL, setProdutosCRL] = useState([]);
  const [produtosTOK, setProdutosTOK] = useState([]);
  const [produtosSEM, setProdutosSEM] = useState([]);
  const [ready, setReady] = useState(false);
  let count = 0;
  let countRequestProducts = 0;
  const accessTokenGS = useContext(MyContext);
  const planoPag = accessTokenGS.planoPag;
  let session = "";
  let rubricaInicial = 0;

  const ARQ = [];
  const CRT = [];
  const CRL = [];
  const TOK = [];
  const SEM = [];

  useEffect(() => {
    const getSessionParams = async () => {
      session = accessTokenGS.accessTokenGS;
      rubricaInicial = accessTokenGS.firstProduct
        ? parseInt(accessTokenGS.firstProduct)
        : 22;
      if (session !== "") {
        await getProducts();
      }
    };

    async function getVar() {
      await getSessionParams();
    }
    getVar();
  }, []);

  async function getProducts() {
    if (session) {
      await api
        .get(`ws_produto/?rubri_inid_rubricamodulo=${moduleID}`, {
          headers: { Authorization: `Bearer ${session}` },
          params: { produ_dmtp_certificadodigital: `${item}` },
        })
        .then((response) => {
          separarProdutos(response.data.detalhe[0].produtos);
          const firstItem = response.data.detalhe[0].produtos.find(
            (element) => element.rubri_inid_rubricaproduto === rubricaInicial
          ); //{
          if (firstItem !== undefined) {
            sessionStorage.setItem("@App:ecnpjA1", JSON.stringify(firstItem));
          }
        })
        .catch((error) => {
          setTimeout(() => {
            if (countRequestProducts <= 10) {
              countRequestProducts++;
              getProducts();
            }
          }, 500);
        });
    } else {
      getProducts();
    }
  }

  const separarProdutos = (produtos) => {
    count += 1;
    if (count <= 1) {
      produtos.forEach((element) => {
        let midiaDef = element.produ_dmtp_midia + "";
        switch (midiaDef) {
          case "ARQ":
            ARQ.push(element);
            break;
          case "CRT":
            CRT.push(element);
            break;
          case "CRL":
            CRL.push(element);
            break;
          case "TOK":
            TOK.push(element);
            break;
          case "SEM":
            SEM.push(element);
            break;
        }
      });
      setProdutosARQ(ARQ);
      setProdutosCRL(CRL);
      setProdutosCRT(CRT);
      setProdutosSEM(SEM);
      setProdutosTOK(TOK);
      setReady(true);
    }
  };

  const chamaArq = () => {
    let itemLayout = item + "";
    if (itemLayout === "NFE") {
      return (
        <>
          {produtosARQ.length > 0 ? (
            <CardProductsV2
              log={log}
              item={produtosARQ}
              card={"1"}
              layout={"col-md-3"}
              img={comprar1}
              planoPag={planoPag}
            />
          ) : null}
          {produtosCRL.length > 0 ? (
            <CardProductsV2
              log={log}
              item={produtosCRL}
              card={"2"}
              layout={"col-md-3"}
              img={comprar2}
              planoPag={planoPag}
            />
          ) : null}
          {produtosCRT.length > 0 ? (
            <CardProductsV2
              log={log}
              item={produtosCRT}
              card={"3"}
              layout={"col-md-3"}
              img={comprar3}
              planoPag={planoPag}
            />
          ) : null}
          {produtosTOK.length > 0 ? (
            <CardProductsV2
              log={log}
              item={produtosTOK}
              card={"5"}
              layout={"col-md-3"}
              img={comprar5}
              planoPag={planoPag}
            />
          ) : null}
          {produtosSEM.length > 0 ? (
            <CardProductsV2
              log={log}
              item={produtosSEM}
              card={"4"}
              layout={"col-md-3"}
              img={comprar4}
              planoPag={planoPag}
            />
          ) : null}
        </>
      );
    } else {
      return (
        <>
          {produtosARQ.length > 0 ? (
            <CardProductsV2
              log={log}
              item={produtosARQ}
              card={"1"}
              layout={"col-md-2"}
              img={comprar1}
              planoPag={planoPag}
            />
          ) : null}
          {produtosCRL.length > 0 ? (
            <CardProductsV2
              log={log}
              item={produtosCRL}
              card={"2"}
              layout={"col-md-2"}
              img={comprar2}
              planoPag={planoPag}
            />
          ) : null}
          {produtosCRT.length > 0 ? (
            <CardProductsV2
              log={log}
              item={produtosCRT}
              card={"3"}
              layout={"col-md-2"}
              img={comprar3}
              planoPag={planoPag}
            />
          ) : null}
          {produtosSEM.length > 0 ? (
            <CardProductsV2
              log={log}
              item={produtosSEM}
              card={"4"}
              layout={"col-md-2"}
              img={comprar4}
              planoPag={planoPag}
            />
          ) : null}
          {produtosTOK.length > 0 ? (
            <CardProductsV2
              log={log}
              item={produtosTOK}
              card={"5"}
              layout={"col-md-2"}
              img={comprar5}
              planoPag={planoPag}
            />
          ) : null}
        </>
      );
    }
  };

  return (
    <div className="Sections mtb-70">
      <div className="container">
        <div className="row">
          <div className="col-md-12 text-center img-products">
            <img src={img} alt={tituloImg} />
          </div>
          <div className="col-md-12">
            <p></p>
            <p className="text-section">{texto}</p>
          </div>
        </div>
        <div className="row d-flex justify-content-center">
          {ready ? chamaArq() : null}
        </div>
      </div>
    </div>
  );
}

export default SectionProducts;
